import EventDispatcher from "../../../../../shared/lib/html5-software-library/src/ranj/util/EventDispatcher";
import AssetLibrary from "../../../../../shared/src/ranj/app/assetloading/AssetLibrary";
import AbstractDebugView from "../../../../../shared/src/ranj/debug/core/view/AbstractDebugView";
import GameConfig from "../../../equalture/flexibility/model/GameConfig";
import GameModel from "../../../equalture/flexibility/model/GameModel";

export default class DebugOutputController extends AbstractDebugView {

    /**
     * 
     * @param {EventDispatcher} dispatcher
     * @param {AssetLibrary} assetLibrary
     * @param {GameConfig} gameConfig
     * @param {GameModel} gameModel
     */
    constructor(dispatcher, assetLibrary, gameConfig, gameModel) {
        const keycode = assetLibrary.getAsset("debugtools_config").keyBindings.debugOutput.charCodeAt(0);
        super(keycode, "ranj/debug/modules/debugoutput/DebugOutputGUI.html", "Debug Output", "width=600,height=600");

        this._dispatcher = dispatcher;
        this._gameConfig = gameConfig;
        this._gameModel = gameModel;

        this._gameModel.addEventListener(GameModel.CONFIG_LOADED, this.configLoaded.bind(this));
    }

    destroy() {
        super.destroy();
        this._gameModel.addEventListener(GameModel.CONFIG_LOADED, this.configLoaded.bind(this));
    }

    onLoad() {
        super.onLoad();
        this._output = this.generateSectionsOutput();
        this._gui.document.getElementById("output").innerHTML = this._output;
        this._gui.document.getElementById("copy").addEventListener("click", this._copy.bind(this));
    }

    configLoaded() {
        // Regenerate output when config is loaded
        this._output = this.generateSectionsOutput();
        this.closePopup();
    }

    generateSectionsOutput() {
        const originalSections = this._gameConfig.originalSections;
        const randomizedSections = this._gameConfig.sections;
        this._output = JSON.stringify(randomizedSections, null, 2);

        const lines = [];
        lines.push(`Seed: ${Math.random.seed}`);
        lines.push(`Ruleset: ${this._gameConfig.rulesetIndex} ${this.displayDetailsRuleSet(this._gameConfig.randomizedSectionsConfig, this._gameConfig.rulesetIndex)}`);
        lines.push("==================================");
        lines.push(...this.getSectionsOutput("<b>Original sections</b>", originalSections));
        lines.push("==================================");
        lines.push(...this.getSectionsOutput("<b>Random sections</b>", randomizedSections));
        lines.push("==================================");

        return lines.join("\n");
    }

    displayDetailsRuleSet(randomizedSections, rulesetIndex) {
        const activeRulesPath = randomizedSections.map(section => section.randomizedRules[rulesetIndex]).join(', ');
        return `[${activeRulesPath}]`
    }

    getSectionsOutput(title, sections) {
        const lines = [];
        lines.push(`${title}`);
        sections.forEach((section, idx) => {
            lines.push(...this.getSectionOutput(section, idx, "\t"));
        });
        return lines;
    }

    getSectionOutput(section, index, prefix) {
        const lines = [];
        var ruleChange = "";
        if (section.action == "rulechange") {
            ruleChange = " (Rule Change)";
        }

        lines.push(`<b>${prefix} Section ${index}${ruleChange}</b>`);

        var ignoreTracks = false;

        let tracks = section.lanes.map((lane, i) => {
            if (lane.color == "f" || lane.color == "F" || lane.shape == "x") {
                ignoreTracks = true;
                return "";
            }
            const color = rulesEquivalents[lane.color];
            const shape = rulesEquivalents[lane.shape];
            var prefixBold = "";
            var suffixBold = "";
            if (lane.speed == 3) {
                lines.push(`${prefix} ${prefix} Solution: ${color}/${shape}`);
                prefixBold = "<b>";
                suffixBold = "</b>";
            }

            return `${prefixBold}${color}/${shape} (${lane.speed})${suffixBold}`;
        });
        if (tracks.every(track => track === "")) {
            lines.push(`${prefix} ${prefix} No tracks`);
        } else {
            lines.push(`${prefix} ${prefix} Tracks: ${tracks.join(' | ')}`);
        }
        return lines;
    }

    _copy() {
        this._gui.navigator.clipboard.writeText(this._output).then(() => {
            this.setStatus("Output copied.");
        }, (err) => {
            this.setStatus("Failed to copy!");
        });

    }

    setStatus(str, duration = 2000) {
        this._gui.document.getElementById("status").innerHTML = str;
        if (duration) {
            setTimeout(() => {
                this._gui.document.getElementById("status").innerHTML = "";
            }, duration);
        }
    }
}
const rulesEquivalents = {
    a: 'circle',
    b: 'star',
    c: 'diamond',
    d: 'triangle',
    f: '-',
    F: '-',
    x: '-',
    1: 'cyan',
    2: 'blue',
    3: 'yellow',
    4: 'green'
};
